module.exports = __webpack_public_path__ + "static/media/Kmart-ErrorMessage-110222-desktop.788c8077.png";